import React from 'react';
import PropTypes from 'prop-types';
import ErrorIndicator from '../assets/ErrorIndicator';
import WarningIndicator from '../assets/WarningIndicator';

var ActivationIndicatorIcon = function ActivationIndicatorIcon(_ref) {
  var className = _ref.className,
      density = _ref.density,
      validationState = _ref.validationState;
  return validationState === 'error' ? /*#__PURE__*/React.createElement(ErrorIndicator, {
    className: className,
    density: density
  }) : /*#__PURE__*/React.createElement(WarningIndicator, {
    className: className,
    density: density
  });
};

process.env.NODE_ENV !== "production" ? ActivationIndicatorIcon.propTypes = {
  className: PropTypes.string,
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * Error state string: 'warning', 'error' or '' (default)
   */
  validationState: PropTypes.oneOf(['warning', 'error', ''])
} : void 0;
export default ActivationIndicatorIcon;